import { AnyAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import authenticationSlice from './slicers/authenticationSlice';
import buildingSlice from './slicers/buildingSlice';
import deviceSlice from './slicers/deviceSlice';
import floorSlice from './slicers/floorSlice';
import organizationSlice from './slicers/organizationSlice';
import roomSlice from './slicers/roomSlice';
import tagSlice from './slicers/tagSlice';
import timeseriesSlice from './slicers/timeseriesSlice';
import modalitySlice from './slicers/modalitySlice';

const combinedReducer = combineReducers({
	authentication: authenticationSlice.reducer,
	building: buildingSlice.reducer,
	device: deviceSlice.reducer,
	floor: floorSlice.reducer,
	modality: modalitySlice.reducer,
	organization: organizationSlice.reducer,
	room: roomSlice.reducer,
	tag: tagSlice.reducer,
	timeseries: timeseriesSlice.reducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
	if (action.type === 'reset-state') {
		state = {} as RootState;
	}
	return combinedReducer(state, action);
};

const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware(getDefaultMiddlewares) {
		if (process.env.NODE_ENV === 'production') {
			return getDefaultMiddlewares();
		} else {
			return getDefaultMiddlewares();
		}
	},
});

export type AppDispatch = typeof store.dispatch;
export default store;
